import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { ShowToastrService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { InvBalance } from "../../models/inv-balance.model";
import { Warehouse } from "../../models/warehouse.model";

@Component({
  selector: "ngx-inv-balance-form",
  templateUrl: "./inv-balance-form.component.html",
  styleUrls: ["./inv-balance-form.component.scss"],
})
export class InvBalanceFormComponent extends BaseFormComponent<InvBalance> {
  hcolumns: form_control[];
  currentWarehouse: Warehouse;
  dataList: InvBalance[];
  constructor(
    sts: ShowToastrService,
    __id: FormContainerModel,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    _tabsservice: TabularService
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
  }
  async ngOnInit() {
    this.apiName = "InvBalance";
    this.areaName = "Inventory";
    this.label = this.translate("ClientApp.BackOffice.INV.InvBalance.BalanceControl");
    super.ngOnInit();
  }
  async setColumns() {
    this.httpCommonService
      .getControlsList(this.apiName.split("/")[0])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (data) => {
          if (data) {
            this.orignalColumns = (data as form_control[]).filter((f) => f.name === "WarehouseId");
            this.hcolumns = this.orignalColumns;
            this.columns = data as form_control[];
            this.columns = this.columns.sort((a, b) => a.order - b.order);
            this.setColumnAttribute();
            this.setFormGroup(this.model);
          }
        },
        (error) => this.getFailedHelper(error)
      );
  }
  onChange($event: Warehouse) {
    if ($event) {
      this.currentWarehouse = $event;
      this.model.WarehouseId = $event.Id;
      this.loadData($event);
    }
  }
  loadData(event: Warehouse) {
    this.httpCommonService
      .getList(this.apiName + "/GetByWarehouseId/" + event.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (row) => (this.dataList = row as []),
        (error) => this.saveFailedHelper(error)
      );
  }
  beforupdate() {
    this.dataList.forEach((x) => {
      x.WarehouseId = this.currentWarehouse.Id;
      x.WarehouseTitle = this.currentWarehouse.Title;
      x.WarehouseCode = this.currentWarehouse.Code;
    });
  }
  public async save() {
    if (!this.isSaving) {
      this.beforupdate();
      if (this.isValid()) {
        this.sts.showToast("info", "", this.translate("ClientApp.BackOffice.INV.InvBalance.InProgress"));
        this.isSaving = true;
        this.isSaved = false;
        if (this.dataList && this.dataList.length > 0) {
          this.httpCommonService
            .createlist(this.apiName + "/BulkIsertUpdateDelete", this.dataList)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
              (row) => this.saveSuccessHelper(row),
              (error) => this.saveFailedHelper(error)
            );
        }
      }
    }
  }
}
